import { initApp } from "./ui/app";
import { showLobby } from "./ui/lobby";

initApp();
showLobby();
